import "./Css/DefaultPaper.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

const examInfo = {
  name: "पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा",
  class: "५ वी",
  subject: "मराठी",
};

const questions = [
  {
    id: 1,
    question: "“तो शाळेत जातो.” या वाक्यातील क्रियापद कोणते?",
    options: ["तो", "शाळेत", "जातो", "वाक्य"],
  },
  {
    id: 2,
    question: "“फुल” या शब्दाचे अनेकवचन काय?",
    options: ["फुला", "फुले", "फुली", "फुला"],
  },
  {
    id: 3,
    question: "“सुंदर” या शब्दाचा विरुद्धार्थी शब्द कोणता?",
    options: ["वाईट", "कुरूप", "चांगला", "भला"],
  },
  {
    id: 4,
    question: "“आई मला बोलावते.” — या वाक्यात कर्ता कोण?",
    options: ["आई", "मला", "बोलावते", "वाक्य"],
  },
  {
    id: 5,
    question: "“तो शाळेत जातो.” या वाक्यातील क्रियापद कोणते?",
    options: ["तो", "शाळेत", "जातो", "वाक्य"],
  },
  {
    id: 6,
    question: "“फुल” या शब्दाचे अनेकवचन काय?",
    options: ["फुला", "फुले", "फुली", "फुला"],
  },
  {
    id: 7,
    question: "“सुंदर” या शब्दाचा विरुद्धार्थी शब्द कोणता?",
    options: ["वाईट", "कुरूप", "चांगला", "भला"],
  },
  {
    id: 8,
    question: "“आई मला बोलावते.” — या वाक्यात कर्ता कोण?",
    options: ["आई", "मला", "बोलावते", "वाक्य"],
  },
];

const ExamPreview = () => {
      const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchQuery, setSearchQuery] = useState('');

   const filteredData = questions.filter((q) =>
  q.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
  q.id.toString().includes(searchQuery)
);


const totalPages = Math.ceil(filteredData.length / rowsPerPage);

const paginatedData = filteredData.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);
    
       const handlePreviewClick = () => {
    navigate("/dashboard/previewpaper");
  };
  return (
    <div className="exam-pagee">
     <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन   &gt;&gt;परीक्षा तयार करा &gt;&gt;By Default &gt;&gt; <span>View</span> 
        </h3>

        <div className="edit-btnn">
        <button
          className="builder-container-preview-btn"
          onClick={handlePreviewClick}
        >
          प्रिव्ह्यू
        </button>
        </div>
      </div>

      {/* Exam Info */}
      <div className="exam-info">
        <div><b>परीक्षेचे नाव :</b> {examInfo.name}</div>
        <div><b>इयत्ता :</b> {examInfo.class}</div>
        <div><b>विषय :</b> {examInfo.subject}</div>
      </div>

      {/* Questions */}
      <div className="question-section">
        <h3>एकुण जोडलेले प्रश्न</h3>

        {paginatedData.map((q) => (

          <div className="question-card" key={q.id}>
            <p className="question-text">
              {q.id}) {q.question}
            </p>
            <ul className="optionsu">
              {q.options.map((opt, index) => (
                <li key={index}>
                  {index + 1}) {opt}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
       <div className='que-pagination-container'>
      <div className="que-pagination-controlss">
        <button
          className="que-pagination-btn"
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
         &lt;
        </button>

        {[...Array(totalPages).keys()]
          .map((_, i) => i + 1)
          .slice(
            Math.max(currentPage - 2, 0),
            Math.min(currentPage + 1, totalPages)
          )
          .map((page) => (
            <button
              key={page}
              className={`que-pagination-btn ${
                currentPage === page ? 'active' : ''
              }`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}

        <button
          className="que-pagination-btn"
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
           &gt;
        </button>
         {/* Rows per page and range info */}
      <div className="que-pagination-controls">
        <span className="que-rows-label">Rows per page:</span>
        <select
          value={rowsPerPage}
          onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
          className="que-rows-dropdown"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
        </select>
</div>
      </div>
</div>
    </div>
  );
};

export default ExamPreview;
